// Site-wide constants for U2 Gaming
export const BRAND = {
  name: "U2 Gaming",
  tagline: "Malaysia's #1 Online Casino",
  logo: "https://customer-assets.emergentagent.com/job_77f7f3a9-a3b7-4b36-a1d4-8ea0b630ca47/artifacts/0q7u35f0_u2.png",
};

export const LINKS = {
  login: "https://regismyr.wlrdr.xyz/RE/NjljZGRlZWVlNjY0NjRmNjRiN2U0OWQ4",
  register: "https://regismyr.wlrdr.xyz/RE/NjljZGRlZWVlNjY0NjRmNjRiN2U0OWQ4",
  telegram: "https://t.me/+JVLa3hDzSxk3NzI1",
  whatsappNumber: "011-1203 1763",
  whatsappIntl: "60112031763",
  whatsappLink: "https://wa.me/60112031763",
  // Auto generated QR for whatsapp link
  whatsappQR:
    "https://api.qrserver.com/v1/create-qr-code/?size=420x420&color=ff7a00&bgcolor=0a0a0a&margin=10&qzone=2&data=https%3A%2F%2Fwa.me%2F60112031763",
  telegramQR:
    "https://api.qrserver.com/v1/create-qr-code/?size=420x420&color=ff7a00&bgcolor=0a0a0a&margin=10&qzone=2&data=https%3A%2F%2Ft.me%2F%2BJVLa3hDzSxk3NzI1",
};

export const GAME_GALLERY = [
  "https://customer-assets.emergentagent.com/job_play-orange-world/artifacts/85bjhc0j_image.png",
  "https://customer-assets.emergentagent.com/job_play-orange-world/artifacts/g1g92vy8_image.png",
  "https://customer-assets.emergentagent.com/job_play-orange-world/artifacts/0j44e07u_image.png",
  "https://customer-assets.emergentagent.com/job_play-orange-world/artifacts/augtlh23_image.png",
  "https://customer-assets.emergentagent.com/job_play-orange-world/artifacts/wl6uh5qy_image.png",
];

export const GAME_CATEGORIES = [
  {
    id: "slots",
    name: "Slots",
    desc: "500+ premium video slots from top providers worldwide",
    icon: "Gamepad2",
    image: GAME_GALLERY[0],
  },
  {
    id: "live",
    name: "Live Casino",
    desc: "HD-streamed Baccarat, Roulette & Blackjack — 24/7",
    icon: "Spade",
    image: GAME_GALLERY[3],
  },
  {
    id: "sports",
    name: "Sports",
    desc: "Football, Basketball, eSports & in-play live odds",
    icon: "Trophy",
    image: GAME_GALLERY[4],
  },
  {
    id: "fishing",
    name: "Fishing",
    desc: "Action-packed fish shooter & arcade jackpots",
    icon: "Fish",
    image: GAME_GALLERY[1],
  },
];

export const PROMOS = [
  {
    badge: "200%",
    badgeLabel: "Welcome Bonus",
    title: "New Member First Deposit",
    desc: "Register your U2 Gaming account today. Get up to 200% bonus on your first deposit — claimed instantly.",
    cta: "Claim Now",
  },
  {
    badge: "30%",
    badgeLabel: "Daily Bonus",
    title: "Daily Reload Bonus",
    desc: "Enjoy a 30% bonus every time you top up. The promo resets every 24 hours, more to play every single day.",
    cta: "View Details",
  },
  {
    badge: "10%",
    badgeLabel: "Weekly Cashback",
    title: "Weekly Cash Rebate",
    desc: "Win or lose, U2 gives back. Receive 10% cashback on weekly net losses — auto-credited every week.",
    cta: "Join Now",
  },
];

export const REASONS = [
  {
    icon: "ShieldCheck",
    title: "Safe & Secure",
    desc: "128-bit SSL encryption protects every transaction. Certified RNG for provably fair gameplay.",
  },
  {
    icon: "Zap",
    title: "Instant Deposits",
    desc: "Maybank, CIMB, Public Bank, RHB, Hong Leong + TnG & Boost. Withdrawals in 3 minutes.",
  },
  {
    icon: "Library",
    title: "Massive Library",
    desc: "30+ world-class providers — Pragmatic, Evolution, Playtech, JILI, JDB, Spade & more.",
  },
  {
    icon: "Gift",
    title: "Generous Promos",
    desc: "Welcome bonus 200%, daily reloads, weekly cashback, referral rewards & VIP perks.",
  },
  {
    icon: "Smartphone",
    title: "Mobile First",
    desc: "No download required. Optimized for every smartphone — iOS & Android browsers.",
  },
  {
    icon: "Headphones",
    title: "24/7 Support",
    desc: "Bilingual support team online round-the-clock via Telegram & WhatsApp.",
  },
];

export const FAQS = [
  {
    q: "What is U2 Gaming?",
    a: "U2 Gaming is Malaysia's premier online casino platform offering slots, live casino, sports betting, and fishing games from top international providers. Built specifically for Malaysian players with full MYR support and 24/7 customer service.",
  },
  {
    q: "How do I login to U2 Gaming?",
    a: "Click the Login button at the top right, enter your registered username and password, then sign in. Your U2 Gaming account is accessible instantly. Forgot password? Use the password reset option.",
  },
  {
    q: "How do I register on U2 Gaming?",
    a: "Registering is quick and free. Click Register, fill in your basic details — username, password, mobile number — complete verification, and your account is ready in under 2 minutes.",
  },
  {
    q: "Is U2 Gaming available in Malaysia?",
    a: "Yes — U2 Gaming is purpose-built for Malaysia. We support MYR transactions, all major Malaysian banking methods, and bilingual support in English & Mandarin.",
  },
  {
    q: "What deposit & withdrawal methods do you support?",
    a: "All major Malaysian banks — Maybank, CIMB, Public Bank, RHB, Hong Leong — plus digital wallets such as Touch 'n Go, Boost & DuitNow QR. Fast, secure, hassle-free.",
  },
  {
    q: "Is U2 Gaming safe and secure?",
    a: "Absolutely. We use 128-bit SSL encryption to protect every transaction. Our platform operates under a valid gaming license with certified RNG audits for fair play.",
  },
];

export const MARQUEE_ITEMS = [
  "Welcome to U2 Gaming Malaysia — Best Online Casino!",
  "U2 Gaming Register now & claim 200% Welcome Bonus!",
  "Login and play 500+ games from top providers!",
  "24/7 Live Chat Support via Telegram & WhatsApp!",
  "Fast withdrawals in 3 minutes — Maybank, CIMB, TnG & more!",
];
